<template>
  <a-modal
      title="支付出库"
      :visible="visible"
      :okText="'确认出库'"
      @ok="handleOk"
      @cancel="handleCancel"
      :confirmLoading="confirmLoading"
      width="600px"
  >
    <a-alert
        v-if="hasUnpaidOrders"
        message="包含未支付订单，请先完成支付！"
        type="error"
        show-icon
        style="margin-bottom: 16px"
    />
    <a-table
        :columns="columns"
        :dataSource="selectedOrders"
        :pagination="false"
        size="small"
        bordered
    >
      <template slot="isPayment" slot-scope="text">
        <a-tag :color="text == '1' ? 'green' : 'red'">
          {{ text == '1' ? '已收款' : '未收款' }}
        </a-tag>
      </template>
    </a-table>

    <a-form :form="form" style="margin-top: 16px">
    </a-form>
  </a-modal>
</template>

<script>
import {paymentOutbound} from "api/app";

export default {
  name: 'PaymentOutboundModal',
  props: {
    visible: Boolean,
    selectedOrders: Array
  },
  data() {
    return {
      confirmLoading: false,
      form: this.$form.createForm(this),
      columns: [
        {
          title: '标签单号',
          dataIndex: 'barCodeNo',
          width: 150
        },
        {
          title: '运单号',
          dataIndex: 'waybillNumber',
          width: 150
        },
        {
          title: '支付状态',
          dataIndex: 'isPayment',
          scopedSlots: {customRender: 'isPayment'},
          width: 100
        }
      ]
    }
  },
  computed: {
    hasUnpaidOrders() {
      return this.selectedOrders.some(order => order.isPayment != '1')
    }
  },
  methods: {
    handleOk() {
      this.form.validateFields((err) => {
        if (!err) {
          if (this.hasUnpaidOrders) {
            this.$message.error('存在未支付订单，无法完成出库操作！')
            return
          }

          // 添加确认提示
          this.$confirm({
            title: '确认出库',
            content: '该操作会进行已收款订单签收出库，确认需要进行吗？',
            okText: '确认',
            cancelText: '取消',
            onOk: () => {
              this.confirmLoading = true
              const orderIds = this.selectedOrders.map(order => order.barCodeNo)
              this.handlePaymentOutboundSubmit(orderIds)
            },
            onCancel: () => {
              console.log('取消出库操作')
            }
          })
        }
      })
    },
    // 实际提交支付出库
    handlePaymentOutboundSubmit(orderIds) {
      const params = {
        orderIds: orderIds
      }
      paymentOutbound(params).then(res => {
        if (res.code === 200) {
          this.$notification.success({
            message: 'success', // 标题
            description: this.$t('dashboard.outbound.outboundSuccess'), // 详细描述
            duration: 5, // 5秒后自动关闭（0 表示不自动关闭）
            placement: 'topRight', // 位置：topLeft | topRight | bottomLeft | bottomRight
            style: {
              width: '400px', // 自定义宽度
              top: '100px', // 调整位置
              right: '50px', // 调整位置
              background: '#f6ffed',  // 背景色
              border: '1px solid #b7eb8f',  // 边框
              borderRadius: '4px',
              boxShadow: '0 3px 6px rgba(0, 0, 0, 0.1)',
            },
          });
          this.$emit('success') // 通知父组件操作成功
          this.form.resetFields()
        } else {
          this.$notification.error({
            message: 'error', // 标题
            description: res.msg || this.$t('dashboard.outbound.cancelPayFailed'), // 详细描述
            duration: 5, // 5秒后自动关闭（0 表示不自动关闭）
            placement: 'topRight', // 位置：topLeft | topRight | bottomLeft | bottomRight
            style: {
              width: '400px', // 自定义宽度
              top: '100px', // 调整位置
              right: '50px', // 调整位置
              background: '#fff2f0', // 背景色
              border: '1px solid #ffccc7', // 边框色
              borderRadius: '4px',
              boxShadow: '0 3px 6px rgba(0, 0, 0, 0.1)',
            },
          });
        }
      }).catch(error => {
        this.$message.error(error.message || '请求失败')
      }).finally(() => {
        this.confirmLoading = false
      })
    },
    handleCancel() {
      this.form.resetFields()
      this.$emit('cancel')
    }
  }
}
</script>
